var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeAllMoreAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E4E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 18.3307C18.1839 18.3307 18.3332 18.1815 18.3332 17.9974C18.3332 17.8133 18.1839 17.6641 17.9998 17.6641C17.8157 17.6641 17.6665 17.8133 17.6665 17.9974C17.6665 18.1815 17.8157 18.3307 17.9998 18.3307Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 22.3307C18.1839 22.3307 18.3332 22.1815 18.3332 21.9974C18.3332 21.8133 18.1839 21.6641 17.9998 21.6641C17.8157 21.6641 17.6665 21.8133 17.6665 21.9974C17.6665 22.1815 17.8157 22.3307 17.9998 22.3307Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 14.3307C18.1839 14.3307 18.3332 14.1815 18.3332 13.9974C18.3332 13.8133 18.1839 13.6641 17.9998 13.6641C17.8157 13.6641 17.6665 13.8133 17.6665 13.9974C17.6665 14.1815 17.8157 14.3307 17.9998 14.3307Z",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeAllMoreAction);
export default __webpack_public_path__ + "static/media/seeAllMoreAction.c4e32d891197fa161854b08d21b3e40d.svg";
export { ForwardRef as ReactComponent };